/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
import React, { Component, Fragment } from 'react';

import styled from 'styled-components';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import uniqueId from 'lodash/uniqueId';
import { Alert } from 'react-bootstrap';
import { AxiosError } from 'axios';
import { v4 } from 'uuid';

import {
  ensureEndsWith,
  getMatchByPath,
  isMobileResolution,
  promiseLikeSetState,
  trackMixpanel,
} from '../infrastructure/utils/common';
import FieldView from '../components/utils/FieldView';
import TopPanel from '../components/utils/TopPanel';
import { setFilterData, setFilterFlag } from '../actions/ordersActions';
import DollarOutput from '../components/utils/DollarOutput';
import Spinner from '../components/utils/Spinner';
import * as Service from '../services/OrdersService';
import * as PartyService from '../services/PartiesService';
import * as ActivityService from '../services/ActivitiesService';
import '../styles/containers/Order.css';
import {
  allowedToCancelOrder,
  allowedToFulfillOrder,
  getOrderDiscount,
  getOrderQaAnswers,
  isOrderCancelled,
  isOrderFulfilled,
  isOrderPending,
  sortBach,
} from '../infrastructure/utils/order';
import OrderStripeCharges from '../components/stripe/OrderStripeCharges';
import OrderCancellationModal from '../components/orders/OrderCancellationModal';
import CustomerBox from '../components/order/CustomerBox';
import BookingOptionFields from '../components/order/BookingOptionFields';
import {
  getActivitySource,
  isActivityHidden,
  isActivityTagApplied,
} from '../infrastructure/utils/activities';
import EditOrderForm from '../components/forms/EditOrderForm';
import CardDetailsView from '../components/order/CardDetailsView';
import AlertWrapper from '../components/utils/AlertWrapper';
import Error from '../components/stateMessage/Error';
import { getConfig } from '../config';
import TransactionLedger from '../components/stripe/Transactions/TransactionLedger';
import AdditionalCharge from '../components/utils/AdditionalCharge';
import {
  Activity,
  ActivitySource,
  BookingOption,
  Location,
} from '../types/Activity';
import { getMembers } from '../infrastructure/utils/events';
import {
  FullOrderBookingOption,
  Order,
  OrderAttendees,
  OrderBookingOption,
  OrderDiscount,
  OrderHistoryRecord,
} from '../types/Order';
import ConfirmOrderPriceModal, {
  ConfirmOrderPriceModalInputProps,
} from '../components/order/ConfirmOrderPriceModal';
import { useStripeAmount } from '../infrastructure/hooks/useStripeAmount';
import {
  isRedeamOrPeek,
  isRefundRequestSupported,
} from '../components/forms/EditPeekAndRedeamOrderForm/helpers';
import ItemActions from '../components/ItemActions/ItemActions';
import {
  getBookingReference,
  getOrderActions,
} from '../infrastructure/constants/orders';
import { SelectedOrderUpdateOption } from '../types/OrderUpdateOption';
import OrderHistory from '../components/orders/OrderHistory/OrderHistory';
import LedgerEntry from '../types/LedgerEntry';
import PriceBreakdownModal from '../components/order/PriceBreakdown/PriceBreakdownModal';
import ApproveRefundModal, {
  ApproveRefundModalProps,
} from '../components/order/ApproveRefundModal/ApproveRefundModal';
import { getAmountToTransfer } from '../components/order/helpers';
import { ActivityContext } from '../contexts/Activity';
import { LedgerContext } from '../contexts/LedgerContext';
import type { ModalState } from '../types/ModalState';
import RequestRefundModal, {
  RequestRefundModalProps,
} from '../components/stripe/RequestRefundModal';
import ManagersSection from '../components/order/ManagersSection';

type EditableFields = {
  startDateTime: Order['startDateTime'];
  endDateTime: Order['endDateTime'];
  timeslot: OrderBookingOption['timeslot'];
  discount: Order['discount'];
};

type ConfirmOrderPriceModalState = ModalState<ConfirmOrderPriceModalInputProps>;
type PriceBreakdownModalState = ModalState<LedgerEntry>;
type ApproveRefundModalState = ModalState<ApproveRefundModalProps>;
type RequestRefundModalState = ModalState<RequestRefundModalProps>;

class State {
  originalActivity: Activity | null = null;
  deactive = false;
  order: (Order & { id: string }) | null = null;
  backpage = false;
  orderUpdated = false;
  dateUpdated = false;
  error: string | undefined = undefined;
  errorTimeoutId: NodeJS.Timeout | undefined = undefined;
  refundModal = null;
  loading = false;
  id = null;
  isEditOpen = false;
  isCancelOpen = false;
  cardholderId = null;
  cardDetails = null;
  showCardDetailsModal = false;
  alert: string | undefined = undefined;
  alertTimeoutId: NodeJS.Timeout | undefined = undefined;
  orderHistory: OrderHistoryRecord[] = [];
  orderLocation?: Location = undefined;

  activity?: Activity = undefined;
  selectedActivity?: Activity = undefined;
  isActivityHidden: boolean = false;

  orderOptionsMap = new Map<string, FullOrderBookingOption>();
  orderOptions: Array<FullOrderBookingOption> = [];
  activityOptionsMap = new Map<string, BookingOption>();
  activityOptions: Array<BookingOption> = [];

  allPartyMembersAttendees: Array<OrderAttendees> = [];

  fields: Partial<EditableFields> = {};

  confirmOrderPriceModal: ConfirmOrderPriceModalState = { visible: false };
  confirmResult?: SelectedOrderUpdateOption = undefined;

  discount?: OrderDiscount = undefined;

  priceBreakdownModal: PriceBreakdownModalState = { visible: false };
  approveRefundModal: ApproveRefundModalState = { visible: false };
  requestRefundModal: RequestRefundModalState = { visible: false };
}

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  h4 {
    color: #138a1e;
  }
`;

const splitBookingOptions = (order, activity) => {
  const activityOptionsMap = new Map<string, BookingOption>();

  // create map for all existing booking options
  (activity?.bookingOptions || []).forEach(opt => {
    activityOptionsMap.set(opt.id, opt);
  });

  const orderOptions: FullOrderBookingOption[] = [];
  const orderOptionsMap = new Map<string, FullOrderBookingOption>();
  const usedOptionsIds = new Set<string>();

  // for each booked option
  (order?.bookingOptions || []).forEach(bookedOption => {
    const bookingOption = activityOptionsMap.get(bookedOption.id);
    const fullOption = { ...(bookingOption || {}), ...bookedOption };

    // fill order options and store used option id
    orderOptions.push(fullOption);
    orderOptionsMap.set(fullOption.lineItemId, fullOption);
    usedOptionsIds.add(fullOption.id);
  });

  // remove used options from activity options list
  usedOptionsIds.forEach(id => {
    activityOptionsMap.delete(id);
  });
  const activityOptions = Array.from(activityOptionsMap.values());

  return {
    orderOptionsMap,
    orderOptions,
    activityOptionsMap,
    activityOptions,
  };
};
const resizeAttendees = (attendees: OrderAttendees[], length: number) => {
  if (attendees.length < length)
    return [...attendees, ...Array(length - attendees.length).fill({})];

  return attendees.slice(0, length);
};
const convertToOrderOption = (
  option: FullOrderBookingOption
): OrderBookingOption => {
  return {
    id: option.id,
    attendees: option.attendees,
    location: option.location,
    timeslot: option.timeslot,
    lineItemId: option.lineItemId,
  };
};

const hasBookingChanges = (
  oldOptions: OrderBookingOption[],
  newOptionsMap: Map<string, OrderBookingOption>
) => {
  const hasOptionsNumberChanged = oldOptions.length !== newOptionsMap.size;
  const hasOptionsChanges = oldOptions.some(opt => {
    const newOption = newOptionsMap.get(opt.lineItemId);
    if (!newOption) return true;

    return newOption.attendees.length !== opt.attendees.length;
  });

  return hasOptionsNumberChanged || hasOptionsChanges;
};

interface OrderPageProps {
  history: any;
  activateFilter: (activate: boolean) => void;
  setFilter: (filter: any) => void;
  mixpanel: any;
  currentUser: any;
}

class OrderPage extends Component<OrderPageProps> {
  state = new State();

  async componentDidMount() {
    const { history } = this.props;
    try {
      if (history.length > 2) {
        this.setState({ backpage: true });
      }
      const match = getMatchByPath(
        ensureEndsWith(history.location.pathname, '/'),
        '/orders/:id/*',
        false
      );
      const { id } = match.params;
      const order = await Service.getOrderById(id);
      if (order === null) {
        alert("Order doesn't exist");
        return history.push('/orders');
      }

      const [party, activity] = await Promise.all([
        PartyService.getParty(order?.partyId),
        ActivityService.getById(order?.activityId),
      ]);

      const members = sortBach(getMembers(party));
      const allPartyMembersAttendees = members.map(attendee => {
        return {
          id: attendee.memberId,
          name: attendee.memberName,
        };
      });

      Service.getOrderHistory(order?.id).then(r => {
        this.setState({ orderHistory: r });
      });

      const {
        orderOptionsMap,
        orderOptions,
        activityOptionsMap,
        activityOptions,
      } = splitBookingOptions(order, activity);

      // we check against 'addon' here because booking options may still have undefined subType
      const currentBookingOption: BookingOption | undefined = orderOptions.find(
        option => option.subType !== 'addon'
      );
      // since we don't yet support editing the location on an order, we store this value to apply to updated booking options if we edit them
      const orderLocation =
        currentBookingOption?.locationType === 'atHome'
          ? currentBookingOption.location
          : undefined;

      const fields = {
        startDateTime: order?.startDateTime,
        endDateTime: order?.endDateTime,
      };
      const config = getConfig();
      const { cardholderId } = config.stripe;

      // handle related routes
      let isEditOpen = false;
      let isCancelOpen = false;
      let requestRefundModal: RequestRefundModalState = { visible: false };
      if (match.params[0] === 'edit/') {
        const isFareharbor = activity?.source === ActivitySource.fareharbor;
        const isCancelled = isOrderCancelled(order);
        isEditOpen = !isFareharbor && !isCancelled;

        if (!isEditOpen) {
          this.props.history.push(`/orders/${order?.id}/`);
        }
      } else if (match.params[0] === 'refunds/request/') {
        requestRefundModal = {
          visible: true,
          data: {
            order: { ...order, id },
            onClose: this.handleRequestRefundModalClose,
            variant: 'requestRefundOnly',
          },
        };
      } else if (match.params[0] === 'cancel/') {
        isCancelOpen = allowedToCancelOrder(order);

        if (!isCancelOpen) {
          this.props.history.push(`/orders/${order?.id}/`);
        }
      }

      const { deactive } = this.state;
      if (!deactive) {
        this.setState({
          originalActivity: activity,
          order,
          party,
          activity: order.activity,
          selectedActivity: order.activity,
          id,
          orderOptionsMap,
          orderOptions,
          activityOptionsMap,
          activityOptions,
          fields,
          cardholderId,
          allPartyMembersAttendees,
          orderLocation,
          isActivityHidden: isActivityHidden(activity),
          isEditOpen,
          isCancelOpen,
          requestRefundModal,
        });
      }
    } catch (e) {
      const error = e as AxiosError;
      console.log(error.message);
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
    }
  }

  async componentWillUnmount() {
    const { history, setFilter, activateFilter } = this.props;
    if (history.location.pathname !== '/orders') {
      activateFilter(false);
      setFilter(undefined);
    }
  }

  componentDidUpdate(
    prevProps: Readonly<OrderPageProps>,
    prevState: Readonly<State>
  ) {
    const stateUpdates: Partial<State> = {};
    if (prevState.error !== this.state.error) {
      if (this.state.errorTimeoutId) {
        clearTimeout(this.state.errorTimeoutId);
        stateUpdates.errorTimeoutId = undefined;
      }

      if (this.state.error) {
        stateUpdates.errorTimeoutId = setTimeout(() => {
          this.setState({ error: undefined });
        }, 2500);
      }
    }

    if (prevState.alert !== this.state.alert) {
      if (this.state.alertTimeoutId) {
        clearTimeout(this.state.alertTimeoutId);
        stateUpdates.alertTimeoutId = undefined;
      }

      if (this.state.alert) {
        stateUpdates.alertTimeoutId = setTimeout(() => {
          this.setState({ alert: undefined });
        }, 2500);
      }
    }

    if (Object.keys(stateUpdates).length > 0) this.setState(stateUpdates);
  }

  back = () => {
    const { history } = this.props;
    history.goBack();
  };

  getAttendeeList = (attendees, type, isParty) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { party } = this.state;
    const style: React.CSSProperties = { display: 'flex', flexWrap: 'wrap' };
    if (isParty) {
      return (
        <FieldView name={type} key={type} colStyle={style}>
          {party.members.map(member => {
            const { memberId, memberName } = member;
            return (
              <a
                key={uniqueId(memberId)}
                className='app-link'
                style={{ marginRight: '10px' }}
                onClick={e => {
                  if (!memberId) {
                    return e.preventDefault();
                  }
                }}
                href={`/users/${memberId}`}
              >
                {memberName || 'ghost'}
              </a>
            );
          })}
        </FieldView>
      );
    }
    return (
      <FieldView name={type} key={type} colStyle={style}>
        {attendees.map((attendee, i) => {
          if (i === attendees.length - 1) {
            return (
              <a
                key={uniqueId(attendee.id + type)}
                className='app-link'
                style={{ marginRight: '10px' }}
                onClick={e => {
                  if (!attendee.id) {
                    return e.preventDefault();
                  }
                }}
                href={`/users/${attendee.id}`}
              >
                {attendee.name || 'ghost'}
              </a>
            );
          }
          return (
            <a
              key={uniqueId(attendee.id + type)}
              className='app-link'
              style={{ marginRight: '10px' }}
              onClick={e => {
                if (!attendee.id) {
                  return e.preventDefault();
                }
              }}
              href={`/users/${attendee.id}`}
            >{`${attendee.name || 'ghost'},`}</a>
          );
        })}
      </FieldView>
    );
  };

  getPartyPricingModel = orderId =>
    this.state.orderOptionsMap.get(orderId)?.pricingModel === 'party';

  // eslint-disable-next-line consistent-return
  getAttendeeView = () => {
    const { order, activity } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (order?.bookingOptionId) {
      return this.getAttendeeList(
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        order?.attendees,
        'Attendees',
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        this.getPartyPricingModel(order?.bookingOptionId)
      );
    }
    if (order?.bookingOptions && activity) {
      return order?.bookingOptions.map(option => {
        const category = activity?.bookingOptions.find(
          opt => opt.id === option.id
        );
        const categoryTitle = category ? category.title : 'not existing';
        return this.getAttendeeList(
          option.attendees,
          `Attendees in ${categoryTitle} booking option`,
          this.getPartyPricingModel(option.lineItemId)
        );
      });
    }
  };

  additionalCharges = order =>
    order?.additionalCharges &&
    order?.additionalCharges.map(additionalCharge => {
      const { name, percent, amount } = additionalCharge;
      return (
        additionalCharge &&
        amount > 0 && (
          <AdditionalCharge
            key={uniqueId(amount + percent)}
            amount={amount}
            name={name}
            percent={percent}
          />
        )
      );
    });

  renderFeesAndTaxes = order => {
    const processingFeeInCents = useStripeAmount(order?.processingFee) || 0;
    const totalTaxInCents = useStripeAmount(order?.totalTax) || 0;

    return (
      <>
        {processingFeeInCents !== 0 && (
          <FieldView name='Processing Fee'>
            <DollarOutput value={order?.processingFee} />
          </FieldView>
        )}
        <FieldView name='Total Tax'>
          <DollarOutput
            value={((totalTaxInCents - processingFeeInCents) / 100).toFixed(2)}
          />
        </FieldView>
      </>
    );
  };

  onMarkAsFulfilledClick = async () => {
    const { id } = this.state;
    try {
      this.setState({ loading: true });
      await Service.fulfillOrder(id);
      const { mixpanel, currentUser } = this.props;
      trackMixpanel('OrderFulfilled', { orderId: id }, currentUser, mixpanel);
      this.reload();
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  updateOrder = async () => {
    const { id } = this.state;
    const newOrder = await Service.getOrderById(id);
    this.setState({ order: newOrder });
  };

  createNewCard = async () => {
    const { id, cardholderId } = this.state;
    try {
      this.setState({ loading: true });
      const card = await Service.createNewCard(id, cardholderId);
      this.updateOrder();
      this.getCardDetailsAndCopyNumber(card.id);
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  getCardDetailsAndCopyNumber = async cardId => {
    const cardDetails = await Service.getCardDetails(cardId);
    this.setState({
      cardDetails,
      showCardDetailsModal: true,
      alert: 'Card number copied to clipboard!',
    });
    const cardNumber = cardDetails.number;
    navigator.clipboard.writeText(cardNumber);
  };

  onViewCardClick = async () => {
    const { order } = this.state;
    if (!order?.cardId) {
      this.createNewCard();
    } else {
      this.getCardDetailsAndCopyNumber(order?.cardId);
    }
  };

  onCancelOrderFulfillmentClick = async (
    reason,
    reasonNote,
    isClose: boolean = false
  ) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { id, activity, party, order } = this.state;
    try {
      this.setState({ loading: true });
      await Service.cancelOrderFulfillment(id, reason, reasonNote);
      const { mixpanel, currentUser } = this.props;
      trackMixpanel(
        'OrderFulfillmentCanceled',
        {
          orderId: id,
          productId: activity?.id,
          productName: activity?.title,
          partyId: party.partyId,
          partyName: party.partyName,
          orderSubtotal: order?.subtotalPrice,
          orderTotal: order?.totalPrice,
          userId: currentUser.id,
          reason,
          reasonNote,
        },
        currentUser,
        mixpanel
      );

      window.location.assign(`/orders/${id}/refunds/request/`);
    } catch (e) {
      console.error(e);
      const error = e as AxiosError;
      this.setState({
        error: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      this.setState({ loading: false, isCancelOpen: isClose });
    }
  };

  reload = () => {
    window.location.reload();
  };

  setPartyOptionAttendees = (
    option: FullOrderBookingOption
  ): FullOrderBookingOption => {
    if (option.pricingModel === 'person') return option;
    if (option.attendees.length > 0) return option;

    if (!option.attendeesRequired)
      return { ...option, attendees: this.state.allPartyMembersAttendees };

    return {
      ...option,
      attendees: Array(option.attendeesMinimum || 1).fill({}),
    };
  };

  // creates new OrderBookingOptions using the updated BookingOptions
  setAtHomeLocation = (
    option: FullOrderBookingOption
  ): FullOrderBookingOption => {
    if (option.locationType !== 'atHome') return option;

    return {
      ...option,
      location: this.state.orderLocation,
    };
  };

  confirmOrderPriceChange = async () => {
    const selectedActivity = this.state.selectedActivity as Activity;

    const bookedOptions = this.state.orderOptions
      .map(this.setPartyOptionAttendees)
      .map(this.setAtHomeLocation)
      .map(opt => ({ ...opt, timeslot: this.state.fields.timeslot }))
      .map(convertToOrderOption);

    await promiseLikeSetState(this.setState.bind(this), {
      confirmOrderPriceModal: {
        visible: true,
        data: {
          activityId: selectedActivity.id,
          bookedOptions,
          source: this.state.activity?.source,
          orderId: this.state.order?.id,
          startDateTime: this.state.fields.startDateTime,
          endDateTime: this.state.fields.endDateTime,
        },
      },
    });
  };

  validateOrderUpdates = () => {
    const errors: string[] = [];

    const hasActivity = !!this.state.selectedActivity?.id;
    if (!hasActivity) errors.push('Activity should be selected for order');

    const activityChanged =
      this.state.order?.activityId !== this.state.selectedActivity?.id;
    const noBookedOptions = this.state.orderOptions.length === 0;
    if (hasActivity && activityChanged && noBookedOptions)
      errors.push(
        'At least one booking option required when activity changed in order'
      );

    return errors;
  };

  saveOrderUpdates = async (
    reasonNote?: string,
    selectedUpdateOption?: SelectedOrderUpdateOption
  ) => {
    this.setState({ loading: true });
    try {
      const bookedOptions = this.state.orderOptions
        .map(this.setPartyOptionAttendees)
        .map(this.setAtHomeLocation)
        .map(opt => ({ ...opt, timeslot: this.state.fields.timeslot }))
        .map(convertToOrderOption);

      const updateOption = selectedUpdateOption
        ? {
            id: selectedUpdateOption.id,
            totalAmount: selectedUpdateOption.totalAmount,
          }
        : undefined;

      const updates: Record<string, any> = {
        startDateTime: this.state.fields.startDateTime,
        endDateTime: this.state.fields.endDateTime,
        activityId: this.state.selectedActivity?.id,
        bookingOptions: bookedOptions,
        reasonNote,
        selectedUpdateOption: updateOption,
      };

      if (this.state.fields.discount)
        updates.discount = this.state.fields.discount;

      const updatedOrder = await Service.updateOrder(this.state.id, updates);

      const {
        orderOptionsMap,
        orderOptions,
        activityOptionsMap,
        activityOptions,
      } = splitBookingOptions(updatedOrder, updatedOrder.activity);

      this.setState({
        isEditOpen: false,
        dateUpdated: false,
        order: updatedOrder,
        activity: updatedOrder.activity,
        selectedActivity: updatedOrder.activity,
        discount: undefined,
        orderOptionsMap,
        orderOptions,
        activityOptionsMap,
        activityOptions,
      });

      trackMixpanel(
        'orderUpdated',
        {
          id: this.state.id,
          name: updatedOrder.name,
          status: updatedOrder.status,
          startDateTime: updatedOrder.startDateTime,
          endDateTime: updatedOrder.endDateTime,
        },
        this.props.currentUser,
        this.props.mixpanel
      );
    } catch (e) {
      console.error(e);
      const error = e as AxiosError;
      this.setState({
        error: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleOrderFormSave = async (fields: State['fields']) => {
    // await setting fields, to ensure that state was updated
    await promiseLikeSetState(this.setState.bind(this), {
      fields,
    });
    const errors = this.validateOrderUpdates();
    if (errors.length > 0) {
      this.setState({ error: errors.join('\n') });
      return;
    }

    if (
      hasBookingChanges(
        this.state.order?.bookingOptions || [],
        this.state.orderOptionsMap
      ) ||
      this.state.dateUpdated
    ) {
      await this.confirmOrderPriceChange();

      if (this.state.confirmOrderPriceModal.visible) return;
    }

    await this.saveOrderUpdates();
  };

  onActivitySelect = async (id: string) => {
    const activity = await ActivityService.getById(id);

    const activityOptionsMap = new Map<string, BookingOption>();
    activity?.bookingOptions.forEach(opt =>
      activityOptionsMap.set(opt.id, opt)
    );

    this.setState({
      selectedActivity: activity,
      orderOptionsMap: new Map<string, FullOrderBookingOption>(),
      orderOptions: [],
      activityOptionsMap,
      activityOptions: activity?.bookingOptions,
      isActivityHidden: isActivityHidden(activity),
    });
  };

  onDateUpdated = date => {
    return this.setState({ fields: date, dateUpdated: true });
  };

  addOrderOptions = (option: BookingOption) => {
    const { orderOptionsMap, orderOptions, activityOptionsMap } = this.state;

    if (
      option.subType === 'bookingOption' &&
      orderOptions.some(opt => opt.subType === 'bookingOption')
    ) {
      this.setState({
        error: 'Cannot add more than one booking option',
      });
      return;
    }

    const newOrderOption = {
      ...option,
      lineItemId: v4(),
      attendees: Array(option.attendeesMinimum).fill({}),
    };
    orderOptionsMap.set(newOrderOption.lineItemId, newOrderOption);
    activityOptionsMap.delete(option.id);

    const updates = {
      orderOptionsMap,
      orderOptions: [...orderOptions, newOrderOption],
      activityOptionsMap,
      activityOptions: Array.from(activityOptionsMap.values()),
    };

    this.setState(updates);
  };

  deleteOrderOptions = (option: FullOrderBookingOption) => {
    const { orderOptionsMap, activityOptionsMap, activityOptions } = this.state;

    activityOptionsMap.set(option.id, option);
    orderOptionsMap.delete(option.lineItemId);

    const updates = {
      orderOptionsMap,
      orderOptions: Array.from(orderOptionsMap.values()),
      activityOptionsMap,
      activityOptions: [...activityOptions, option],
    };
    this.setState(updates);
  };

  onClose = () => {
    const { order, activity, originalActivity } = this.state;

    const {
      orderOptionsMap,
      orderOptions,
      activityOptionsMap,
      activityOptions,
    } = splitBookingOptions(order, originalActivity);

    this.setState({
      dateUpdated: false,
      activity,
      selectedActivity: activity,
      orderOptionsMap,
      orderOptions,
      activityOptionsMap,
      activityOptions,
      isEditOpen: false,
    });

    this.props.history.push(`/orders/${order?.id}/`);
  };

  getOldestFulfilledItem = (
    arr: OrderHistoryRecord[]
  ): OrderHistoryRecord | null => {
    const fulfilledItems = arr.filter(obj => obj.status === 'Fulfilled');

    return fulfilledItems.reduce(
      (
        oldestItem: OrderHistoryRecord | null,
        currentItem: OrderHistoryRecord
      ) => {
        if (
          !oldestItem ||
          new Date(currentItem.updatedAt) < new Date(oldestItem.updatedAt)
        ) {
          return currentItem;
        }
        return oldestItem;
      },
      null
    );
  };

  getOrderHistory = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { orderHistory, party } = this.state;

    if (!orderHistory) {
      return null;
    }

    const orderRefunded = orderHistory.find(item => item.status === 'Refunded');
    const orderFulfilled = this.getOldestFulfilledItem(orderHistory);

    return (
      <>
        {!!orderRefunded && (
          <FieldView name='Order Refunded Date'>
            <div key={uniqueId(orderRefunded.updatedAt)}>
              {moment(orderRefunded.updatedAt)
                .tz(party.tz)
                .format('MMM DD YYYY hh:mm A z')}
            </div>
          </FieldView>
        )}
        {!!orderFulfilled && (
          <FieldView name='Order Fulfilled Date'>
            {moment(orderFulfilled.updatedAt)
              .tz(party.tz)
              .format('MMM DD YYYY hh:mm A z')}
          </FieldView>
        )}
      </>
    );
  };

  renderFulfilledInfo = () => {
    const { order } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { status, activity } = order;
    const { source } = activity;
    const isPaidViaStripe = !!source && source !== ActivitySource.bach;
    if (status !== 'Fulfilled') {
      return null;
    }
    return (
      <FlexContainer>
        <button
          type='button'
          className='btn btn-danger order-fulfilled-button pull-right'
          onClick={() => {
            this.setState({ isCancelOpen: true });
          }}
        >
          Cancel Fulfilled
        </button>
        {isPaidViaStripe && <h4>Paid to vendor via Stripe</h4>}
      </FlexContainer>
    );
  };

  onAttendeesNumberChanged = (
    id: FullOrderBookingOption['lineItemId'],
    attendeesNumber: number
  ) => {
    const { orderOptionsMap, activity, orderOptions } = this.state;

    let orderOption: FullOrderBookingOption | undefined;
    if (isRedeamOrPeek(activity?.source)) {
      orderOption = orderOptions[0];
    } else {
      orderOption = orderOptionsMap.get(id);
    }

    if (!orderOption) return;
    if (orderOption.attendees.length === attendeesNumber) return;

    const updatedOption = {
      ...orderOption,
      attendees: resizeAttendees(orderOption.attendees, attendeesNumber),
    };
    orderOptionsMap.set(orderOption.lineItemId, updatedOption);

    const updates = {
      orderOptionsMap,
      orderOptions: Array.from(orderOptionsMap.values()),
    };

    this.setState(updates);
  };

  handleOrderPriceConfirm = async (
    confirmResult?: SelectedOrderUpdateOption
  ) => {
    this.setState({ confirmOrderPriceModal: { visible: false } });
    if (!confirmResult) {
      await this.saveOrderUpdates();
      return;
    }

    const isRefundRequestNeeded =
      isRefundRequestSupported(this.state.activity?.source) &&
      isOrderFulfilled(this.state.order);

    if (confirmResult.totalAmount < 0 && isRefundRequestNeeded) {
      this.setState({
        isEditOpen: false,
        requestRefundModal: {
          visible: true,
          data: {
            order: this.state.order,
            onClose: this.handleRequestRefundModalClose,
            variant: 'updateOrderAndRequestRefund',
            refundAmount: confirmResult.ledgerEntry.totalAmount,
            reverseAmount: getAmountToTransfer(confirmResult.ledgerEntry),
            onOrderUpdate: async (reasonNote: string) => {
              await this.saveOrderUpdates(reasonNote, confirmResult);
            },
          },
        },
        confirmResult,
      });
      return;
    }

    await this.saveOrderUpdates(undefined, confirmResult);
  };
  handleOrderPriceReject = () => {
    this.setState({ confirmOrderPriceModal: { visible: false } });
  };

  handlePriceBreakdownClose = () => {
    this.setState({ priceBreakdownModal: { visible: false } });
  };

  handleCloseApproveRefundModal = (confirmed: boolean) => {
    if (confirmed) {
      setTimeout(() => {
        this.setState({ approveRefundModal: { visible: false } });
        this.reload();
      }, 2500);
    } else {
      this.setState({ approveRefundModal: { visible: false } });
    }
  };
  handleOpenApproveRefundModal = () => {
    const { order } = this.state;
    if (!order) return;

    this.setState({
      approveRefundModal: {
        visible: true,
        data: {
          orderId: order.id,
          status: order.status,
          tz: order.partyTz,
          refundLimits: {
            refund: order.ledger.balance.totalAmount,
            reverse: getAmountToTransfer(order.ledger.balance),
          },
          ledgerEntries: order.ledger.entries.filter(
            e => e.status?.transfer === 'waiting_for_approval'
          ),
          onClose: this.handleCloseApproveRefundModal,
        },
      },
    });
  };

  renderBookingReference(order) {
    const bookingReference = getBookingReference(order);
    if (!bookingReference) return null;

    const { identifier, url } = bookingReference;

    return (
      <FieldView name='Booking Reference'>
        {url ? (
          <a href={url} target='_blank' rel='noreferrer'>
            {identifier}
          </a>
        ) : (
          identifier
        )}
      </FieldView>
    );
  }

  handleRequestRefundModalClose = () => {
    window.location.assign(`/orders/${this.state.order?.id}/`);
  };

  render() {
    const {
      order,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      party,
      backpage,
      activity,
      loading,
      isEditOpen,
      isCancelOpen,
      selectedActivity,
      orderOptions,
      activityOptions,
      confirmOrderPriceModal,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      cardDetails,
      showCardDetailsModal,
      alert,
      error,
      priceBreakdownModal,
      approveRefundModal,
      isActivityHidden,
      requestRefundModal,
    } = this.state;

    if (order === null) {
      return <Spinner />;
    }

    const { source } = activity ?? {};
    const isFareHarbor = activity?.source === 'fareharbor';
    const isCancelled = isOrderCancelled(order);
    const isPaidViaStripe = !!source && source !== ActivitySource.bach;
    const isShownViewCard = !isPaidViaStripe || !source;
    const { communicationStatus, paymentStatus, paymentErrorMessage } =
      order ?? {};

    const lastCommunicationTo =
      communicationStatus?.[communicationStatus?.length - 1]?.to;

    const orderStatus =
      isOrderPending(order) && typeof lastCommunicationTo === 'string'
        ? `Pending (waiting on ${lastCommunicationTo})`
        : order.status;

    const isAllowedToFulfill = allowedToFulfillOrder(order);

    const config = getConfig();

    return (
      <ActivityContext.Provider
        value={{
          hidden: isActivityHidden,
          cancellationPolicy: activity?.cancellationPolicy,
          source: activity?.source,
        }}
      >
        <LedgerContext.Provider
          value={{
            additionalCharges: order.ledger.additionalCharges,
            discount: order.ledger.discount,
          }}
        >
          <AlertWrapper show={!!alert}>
            <p>{alert}</p>
          </AlertWrapper>

          {loading && (
            <div className='sending-status-loader'>
              <Spinner />
            </div>
          )}
          {!!error && <Error text={error} />}
          {approveRefundModal.visible && (
            <ApproveRefundModal {...approveRefundModal.data} />
          )}
          {requestRefundModal.visible && (
            <RequestRefundModal {...requestRefundModal.data} />
          )}
          {priceBreakdownModal.visible && (
            <PriceBreakdownModal
              entry={priceBreakdownModal.data.entry}
              onClose={this.handlePriceBreakdownClose}
            />
          )}
          {confirmOrderPriceModal.visible && (
            <ConfirmOrderPriceModal
              {...confirmOrderPriceModal.data}
              onConfirm={this.handleOrderPriceConfirm}
              onCancel={this.handleOrderPriceReject}
            />
          )}
          {isCancelOpen && (
            <OrderCancellationModal
              onClose={() => {
                this.setState({ isCancelOpen: false });
              }}
              order={order}
              onPress={(reason, reasonNote, isClose) => {
                this.onCancelOrderFulfillmentClick(reason, reasonNote, isClose);
              }}
            />
          )}
          {isEditOpen && selectedActivity && (
            <EditOrderForm
              activityChangeDisabled={activity?.source === ActivitySource.bach2}
              order={order}
              party={party}
              activity={selectedActivity}
              orderOptions={orderOptions}
              setDate={date => this.onDateUpdated(date)}
              activityOptions={activityOptions}
              onActivitySelect={this.onActivitySelect}
              addOrderOptions={this.addOrderOptions}
              deleteOrderOptions={this.deleteOrderOptions}
              closeModal={this.onClose}
              onCancel={this.onClose}
              onSave={this.handleOrderFormSave}
              attendeesChanged={this.onAttendeesNumberChanged}
            />
          )}

          {showCardDetailsModal && (
            <CardDetailsView
              cardDetails={cardDetails}
              closeModal={() => this.setState({ showCardDetailsModal: false })}
            />
          )}
          <TopPanel isDetailsPage>
            <div
              role='button'
              tabIndex={0}
              className='btn-nav back'
              onClick={backpage ? this.back : undefined}
              style={{ marginLeft: '15px' }}
              aria-label='left Align'
            >
              {backpage && (
                <>
                  <i
                    className='fas fa-arrow-left'
                    style={{ paddingRight: '8px' }}
                  />
                  <span className='page-back'>Back</span>
                </>
              )}
              <span className='page-back-mobile'>Order # {order?.id}</span>
            </div>
            {!isFareHarbor && !isCancelled && (
              <button
                type='button'
                className='btn btn-primary pull-right'
                onClick={() => this.setState({ isEditOpen: true })}
              >
                Edit
              </button>
            )}
          </TopPanel>
          <div className='data-container order-container'>
            <div
              className='col-md-6 col-sm-12 col-xs-12'
              style={{ padding: '0px' }}
            >
              <div className='data-box'>
                <h1
                  className='col-md-6 col-sm-6 col-xs-6'
                  style={{ paddingLeft: '0px', marginTop: '0px' }}
                >
                  <b>Order</b>

                  <ItemActions
                    actions={getOrderActions(order)}
                    setCopyAlert={(alert: string) => this.setState({ alert })}
                  />
                </h1>

                <div className='order-button-container'>
                  {order?.status !== 'Draft' &&
                    order?.status !== 'Abandoned' &&
                    isShownViewCard && (
                      <button
                        type='button'
                        className='btn btn-primary order-button'
                        onClick={this.onViewCardClick}
                      >
                        View Card
                      </button>
                    )}
                  {this.renderFulfilledInfo()}
                  {isAllowedToFulfill && (
                    <button
                      type='button'
                      className='btn btn-primary order-button order-invoce-btn'
                      onClick={this.onMarkAsFulfilledClick}
                    >
                      Mark as fulfilled
                    </button>
                  )}
                  {isAllowedToFulfill && (
                    <button
                      type='button'
                      className='btn btn-danger order-fulfilled-button pull-right'
                      onClick={() => {
                        this.setState({ isCancelOpen: true });
                      }}
                    >
                      Cancel Fulfillment
                    </button>
                  )}
                </div>
                <div className='clearfix' />
                {isMobileResolution() && (
                  <FieldView name='Activity'>
                    <a
                      className='app-link'
                      href={`${config.batchAdminURL}/experiences/${activity?.id}`}
                    >
                      {activity?.title}
                    </a>
                  </FieldView>
                )}
                <FieldView name='Status'>{orderStatus}</FieldView>
                {!!paymentErrorMessage && (
                  <Alert bsStyle='danger'>
                    <strong>{paymentErrorMessage}</strong>
                  </Alert>
                )}
                {typeof communicationStatus === 'string' ? (
                  <FieldView name='Communication Status'>
                    {communicationStatus}
                  </FieldView>
                ) : null}
                {typeof paymentStatus === 'string' ? (
                  <FieldView name='Payment Status'>{paymentStatus}</FieldView>
                ) : null}
                <FieldView name='Source'>
                  {getActivitySource(activity?.source)}
                </FieldView>
                {order?.name && (
                  <FieldView name='Order Name'>Order {order?.name}</FieldView>
                )}
                {order?.description !== 'unknown' && (
                  <FieldView name='Description'>{order?.description}</FieldView>
                )}
                <FieldView name='Order Placed Date'>
                  {moment(order?.created)
                    .tz(party.tz)
                    .format('MMM DD YYYY hh:mm A z')}
                </FieldView>
                <FieldView name='Order Updated Date'>
                  {moment(order?.updated)
                    .tz(party.tz)
                    .format('MMM DD YYYY hh:mm A z')}
                </FieldView>
                {this.getOrderHistory()}
                {this.getAttendeeView()}
                <FieldView name='Cancellation Policy'>
                  {activity?.cancellationPolicy}
                </FieldView>
                {this.renderBookingReference(order)}
                <div className='divider' />
                <FieldView name='Subtotal Price'>
                  <DollarOutput value={order?.subtotalPrice} />
                  <button
                    type='button'
                    className='btn btn-link pull-right price-breakdown-link'
                    onClick={() =>
                      this.setState({
                        priceBreakdownModal: {
                          visible: true,
                          data: {
                            entry: order.ledger.balance,
                            charges: order.ledger.additionalCharges,
                            discount: order.ledger.discount,
                          },
                        },
                      })
                    }
                  >
                    Price Breakdown
                  </button>
                </FieldView>
                <FieldView name='Promo Code'>
                  {getOrderDiscount(order?.discount)}
                </FieldView>
                {this.additionalCharges(order)}
                {this.renderFeesAndTaxes(order)}
                <FieldView name='Total Price'>
                  <DollarOutput value={order?.totalPrice} />
                </FieldView>
              </div>
            </div>
            <div
              className='col-md-6 col-sm-12 col-xs-12'
              style={{ padding: '0px' }}
            >
              <div className='data-box'>
                <h4>
                  <b>Event</b>
                </h4>
                <FieldView name='Start'>
                  {moment(order?.startDateTime)
                    .tz(party.tz)
                    .format('MMM DD YYYY hh:mm A z')}{' '}
                </FieldView>
                <FieldView name='End' style={{ marginTop: '8px' }}>
                  {moment(order?.endDateTime)
                    .tz(party.tz)
                    .format('MMM DD YYYY hh:mm A z')}
                </FieldView>
                <FieldView name='BACH Confirmation Code'>
                  {order?.bachConfirmation}
                </FieldView>
                <FieldView name='Vendor Name'>{activity?.vendorName}</FieldView>
                <FieldView name='City'>{activity?.city}</FieldView>
                {!isMobileResolution() && (
                  <FieldView name='Activity'>
                    <a
                      className='app-link'
                      href={`${config.batchAdminURL}/experiences/${activity?.id}`}
                    >
                      {activity?.title}
                    </a>
                  </FieldView>
                )}
                {isActivityTagApplied(
                  'additional-location-needed',
                  activity?.tags
                ) && (
                  <FieldView name='Alt. Drop Off'>
                    {getOrderQaAnswers(order, 'additional-location-needed')}
                  </FieldView>
                )}
                {isActivityTagApplied('notes-needed', activity?.tags) && (
                  <FieldView name='Additional Preferences'>
                    {getOrderQaAnswers(order, 'notes-needed')}
                  </FieldView>
                )}
                {isActivityTagApplied('dietary-needed', activity?.tags) && (
                  <FieldView name='Dietary Restrictions'>
                    {getOrderQaAnswers(order, 'dietary-needed')}
                  </FieldView>
                )}
              </div>
              {order?.bookingOptions && order?.bookingOptions.length > 0 && (
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <BookingOptionFields order={order} activity={activity} />
              )}
              {order?.customer && (
                <CustomerBox customer={order?.customer} party={party} />
              )}
            </div>
            <div
              className='col-md-12 col-sm-12 col-xs-12'
              style={{ padding: '0px' }}
            >
              <div className='data-box'>
                <OrderStripeCharges party={party} order={order} />
              </div>
              <div className='data-box'>
                <h4>
                  <b>Order History</b>
                </h4>
                <OrderHistory
                  historyRecords={this.state.orderHistory}
                  tz={party.tz}
                />
              </div>
              <div className='data-box' style={{ marginBottom: '60px' }}>
                <h4>
                  <b>Transaction Ledger</b>
                </h4>
                <TransactionLedger orderId={order?.id} tz={party.tz} />
              </div>
              <ManagersSection
                currentUser={this.props.currentUser}
                onApproveRequestedRefund={this.handleOpenApproveRefundModal}
              />
            </div>
          </div>
        </LedgerContext.Provider>
      </ActivityContext.Provider>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setFilter: data => dispatch(setFilterData(data)),
    activateFilter: data => dispatch(setFilterFlag(data)),
  };
}

function mapStateToProps(state) {
  return {
    shopify: state.shopify.shopifyLinks,
    currentUser: state.users.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderPage);
